var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "product-insights green-border-box",
      staticStyle: { "margin-bottom": "20px" }
    },
    [
      !_vm.loading
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "row", staticStyle: { "margin-left": "1%" } },
              [
                _vm._m(0),
                _c("div", { staticClass: "col-sm-3" }, [
                  _c(
                    "div",
                    { staticClass: " nopadd text-center sort-control" },
                    [
                      _vm._v("\n        View By last\n        "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.viewby,
                              expression: "viewby"
                            }
                          ],
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.viewby = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c(
                            "option",
                            { attrs: { selected: "", value: "1y" } },
                            [_vm._v("12 Months")]
                          ),
                          _c(
                            "option",
                            { attrs: { selected: "", value: "6m" } },
                            [_vm._v("6 Months")]
                          ),
                          _c(
                            "option",
                            { attrs: { selected: "", value: "3m" } },
                            [_vm._v("3 Months")]
                          ),
                          _c(
                            "option",
                            { attrs: { selected: "", value: "1m" } },
                            [_vm._v("1 Month")]
                          )
                        ]
                      )
                    ]
                  )
                ])
              ]
            ),
            _c(
              "div",
              { staticClass: "row", attrs: { id: "chart" } },
              [
                _c("apexcharts", {
                  attrs: {
                    height: "300",
                    type: "area",
                    options: _vm.chartOptions,
                    series: _vm.chartData
                  }
                })
              ],
              1
            )
          ])
        : _c("h4", { staticStyle: { "text-align": "center" } }, [
            _vm._v("Loading Capas Insights...")
          ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-9" }, [
      _c("h4", { staticStyle: { "margin-left": "5px" } }, [
        _vm._v("CAPAS Activities")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }